import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalService } from './local.service';
import { ToastType } from '../enums';

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    constructor(private httpClient: HttpClient, private localService: LocalService) {}

    get<TResult>(url: string): Observable<TResult>{
        return this.parsePromiseToObserver(this.httpClient.get<TResult>(url).toPromise());
    }


    private parsePromiseToObserver<TResult>(promise: Promise<TResult>): Observable<TResult>{
        return new Observable(observer => {
            this.processRequestPromise(promise)
            .then(result => observer.next(result))
            .catch(error => observer.error(error))
            .finally(() => observer.complete());
        });
    }

    private async processRequestPromise<TResult>(promise: Promise<TResult>) : Promise<TResult> {
        try
        {
            const result = await promise;
            return result;
        } catch(error)
        {
            // Verificamos el tipo del error.
            const httpErrorResponse = <HttpErrorResponse>error;
            if(!httpErrorResponse)
                return null;
            
            if(httpErrorResponse.status === 401){ // UNAUTHORIZED
                return  null;
            }

            if(httpErrorResponse.status === 404){ // NOT FOUND
                this.localService.showToast(
                    "No se pudo encontrar el recurso al que se intenta acceder",
                    "Error de conexión",
                    ToastType.Error
                );
                return  null;
            }

            const validationError = <ValidationErrorResponse>httpErrorResponse.error;
            const systemError = <UnhandledErrorResponse>httpErrorResponse.error;

            if(validationError.IsValidationError){ // VALIDATION
                this.localService.showToast(validationError.Message,"", ToastType.Warning);

            } else if(systemError.IsSystemError){ // UNHANDLED ERROR
                this.localService.showToast(systemError.Message, "Operación fallida",ToastType.Error);

            } else { // UNKNOWN ERROR
                this.localService.showToast(
                    "Ocurrió un error desconocido, por favor contacte a soporte", 
                    "Operación fallida",
                    ToastType.Error
                );
            }

            return null;
        }
    }
}

class ValidationErrorResponse {
    IsValidationError: boolean;
    Message: string;
}

class UnhandledErrorResponse {
    IsSystemError: boolean;
    Message: string;
}